import { RootState } from '@Store/index';
import { getResignationReasonsDict, getResignationStatusesDict } from '@Store/selectors/dictionarySelector';
import { prepareRequisitionInfo } from '@Utils/requisitionInfo';
import { transformDictToOptionsNum } from '@Utils/transformToOptions';
import { createSelector } from '@reduxjs/toolkit';

const resignationRequestSelector = (state: RootState) =>
  state.featureStores.resignationRequest;

export const currentResignationRequest = createSelector(
  resignationRequestSelector,
  ({ resignationRequest }) => resignationRequest
);

export const resignationRequestCreateRequisitionInfo = createSelector(
  [currentResignationRequest, getResignationStatusesDict],
  (resignationRequest, resignationStatuses) => {
    const requisitionInfo = prepareRequisitionInfo(resignationRequest, resignationStatuses);
    return requisitionInfo;
  }
);

export const getReasonOptions = createSelector(
  getResignationReasonsDict,
  (resignationReasons) => {
    const output = transformDictToOptionsNum(resignationReasons);
    return output;
  }
);

export const getReasonLabels = createSelector(
  getResignationReasonsDict,
  (reasons) => {
    const output = reasons.map((reason) => reason.codeDesc);
    return output;
  }
); 

export const getStatusLabels = createSelector(
  getResignationStatusesDict,
  (statuses) => {
    const output = statuses.map((status) => status.codeDesc);
    return output;
  }
);
